export default "#### Green machine event\n\nReceive up to a 3.0% discount off Plenti’s standard rates on all electric and hybrid vehicles at Carma\\*\n";